import React from 'react';
import {
  ThomasCampaign,
  ProductFulfillment,
  ProductFulfillmentVersion
} from 'models/interfaces/index';
import { Link } from 'react-router-dom';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import P3Configuration from 'models/P3Configuration';
import { P3Configuration as IP3Configuration } from 'models/interfaces/P3Configurations';
import { labels, TABS } from './ThomasAdvertiserViewConfig';
import Tab from '../Tab/Tab';
import P3CampaignOptimization from 'views/components/Modal/P3CampaignOptimization';
import { ApolloClient } from 'apollo-client';
import { toast } from 'react-toastify';
import P3TemplateEdit from '../P3Templates/P3TemplateEdit';

import {
  saveP3Configurations,
  duplicateP3Configuration,
  deleteP3Configuration
} from '../P3Templates/P3TemplateEditConfiguration';
import {
  optimizeP3Campaign,
  refetchAdvertiserPageQueries
} from 'views/components/P3Campaigns/P3CampaignOptimization';
import ThomasCampaignList from '../ThomasCampaigns/ThomasCampaignList';
import { ApolloConsumer } from 'react-apollo';
import P3TemplateList from '../P3Templates/P3TemplateList';
import { GET_ADVERTISER_DATA_QUERY } from 'containers/ThomasAdvertiserCampaignsContainer';
import uuid from 'uuid/v4';
import { getClaims, hasFullAccess } from 'util/userAccessValidation';
import { client } from 'services/ApolloClient/Client';

interface ThomasAdvertiserViewProps {
  client: ApolloClient<any>;
  tgramsId: string;
  name: string;
  campaigns: ThomasCampaign[];
  templates: IP3Configuration[];
  productFulfillmentsVersions: ProductFulfillmentVersion[];
  productFulfillments: ProductFulfillment[];
  userInfo: any;
  productName: number;
  productId: number;
  params: any;
  history: any;
}

interface ThomasAdvertiserViewState {
  activeTab: string;
  isModalOpen: boolean;
  currentTemplate: IP3Configuration;
  currentCampaign: ThomasCampaign;
  formTitle: string;
  isEditAssign: boolean;
  isOptimizaModal: boolean;
}

class ThomasAdvertiserView extends React.Component<
  ThomasAdvertiserViewProps,
  ThomasAdvertiserViewState
> {
  constructor(props: ThomasAdvertiserViewProps) {
    super(props);
    this.state = {
      activeTab: props.params.q == 'config' ? TABS.TEMPLATES : TABS.CAMPAIGNS,
      isModalOpen: false,
      isEditAssign: false,
      isOptimizaModal: false,
      formTitle: '',
      currentTemplate: P3Configuration.newCompanyTemplate(this.props.tgramsId),
      currentCampaign: {} as ThomasCampaign
    };
  }

  onClickTabItem = tab => {
    this.setState({ activeTab: tab });
  };

  saveCompanyConfiguration = async (configuration: IP3Configuration) => {
    const { client, history } = this.props;

    console.log('Saving company configuration...');
    console.log('configuration: ', configuration);

    const {
      data: { saveP3Configuration }
    } = await saveP3Configurations(client, configuration);

    console.log('saveP3Configuration: ', saveP3Configuration);

    this.setState(
      {
        currentTemplate: saveP3Configuration
      },
      () => {
        toast.info('Redirecting to Positioning Module to complete configuration...', {
          autoClose: 2000
        });
        setTimeout(() => {
          this.navigateToPositioningModule();
        }, 2000);
      }
    );
  };

  saveCampaignOptimization = async (values: any, client: any) => {
    const postMutateFunc = () => toast.success(' Optimized campaign is being made');

    let response = await optimizeP3Campaign(
      client,
      values.campaignId,
      values.startDate,
      values.name,
      refetchAdvertiserPageQueries(values.tgramsId, values.campaignId),
      postMutateFunc
    );
    this.onClose();
    if (response.data && response.data.saveOptimizeCampaign) {
      toast.info('Redirecting to Optimized Campaign...', {
        autoClose: 2000
      });
      setTimeout(() => {
        this.props.history.push(
          `/advertisers/${values.tgramsId}/campaigns/${response.data.saveOptimizeCampaign}/edit`
        );
      }, 2000);
    }
  };

  navigateToPositioningModule = () => {
    const { currentTemplate } = this.state;

    if (!currentTemplate) {
      console.log('CurrentTemplate is missing.');
      toast.error('Something went wrong navigating to configuration.');
      return;
    }
    let path = `${CONSTANTS.RANKALYZER_BASE_PATH}?config_id=${
      currentTemplate.p3_configuration_id
    }&tgrams_id=${this.props.tgramsId}`;
    window.location.href = path;
  };

  toggleTemplateModal = (template?: IP3Configuration) => {
    const { isModalOpen } = this.state;
    const { tgramsId } = this.props;

    if (template) {
      // template selected from list
      this.setState({
        isModalOpen: !isModalOpen,
        currentTemplate: template,
        formTitle: 'Edit Configuration'
      });
    } else {
      // create template selected, need to create new template
      const newTemplate = P3Configuration.newCompanyTemplate(this.props.tgramsId);

      this.setState({
        isModalOpen: !isModalOpen,
        currentTemplate: newTemplate,
        formTitle: 'Create Configuration'
      });
    }
  };

  toggleOptimizeCampaign = (campaign: ThomasCampaign) => {
    const { isModalOpen } = this.state;
    const { tgramsId } = this.props;
    console.log(`toggle optimize campaign`, campaign);
    this.setState({
      isModalOpen: !isModalOpen,
      isOptimizaModal: true,
      currentCampaign: campaign,
      formTitle: ''
    });
  };

  onClose = () =>
    this.setState({ isModalOpen: false, isEditAssign: false, isOptimizaModal: false });

  render() {
    const {
      name,
      tgramsId,
      campaigns,
      templates,
      productFulfillmentsVersions,
      productFulfillments,
      userInfo,
      productName,
      productId
    } = this.props;
    const {
      activeTab,
      isModalOpen,
      formTitle,
      currentTemplate,
      isOptimizaModal,
      currentCampaign
    } = this.state;
    const isUserAuth = hasFullAccess(userInfo);
    //const claims = getClaims(userInfo);

    const templateRefetchQueries = [
      {
        query: GET_ADVERTISER_DATA_QUERY,
        variables: {
          tgrams_id: tgramsId
        }
      }
    ];

    return (
      <section>
        <div className="flex-row flex-wrap">
          <h1 className="page-title">
            {productName} Campaign: {name}
          </h1>
          {activeTab === TABS.CAMPAIGNS &&
          isUserAuth &&
          productId != CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS ? (
            <Link to={`/advertisers/${tgramsId}/campaigns/create`} className="header-title-btn">
              <button className="header-title-btn btn btn-primary">Create Campaign</button>
            </Link>
          ) : null}
          {activeTab === TABS.TEMPLATES ? (
            <a className="header-title-btn">
              <button
                onClick={() => this.toggleTemplateModal()}
                className="btn btn-primary"
                style={{ float: 'right' }}
              >
                Create Configuration
              </button>
            </a>
          ) : null}
        </div>

        <div className="card">
          <ul className="page-tabs page-tabs--card">
            {labels.map((tab, i) => {
              return (
                <Tab
                  key={`${tab} - ${i}`}
                  activeTab={activeTab}
                  label={tab}
                  onClick={this.onClickTabItem}
                />
              );
            })}
          </ul>

          <div className="content-card content-card--pattern mb-4">
            {isModalOpen && !isOptimizaModal ? (
              <P3TemplateEdit
                isModalOpen={isModalOpen}
                companyName={name}
                formTitle={formTitle}
                template={currentTemplate}
                onClose={this.onClose}
                onSaveConfig={this.saveCompanyConfiguration}
              />
            ) : null}
            {isModalOpen && isOptimizaModal ? (
              // Zero SUm
              <P3CampaignOptimization
                isModalOpen={isModalOpen}
                onClose={this.onClose}
                campaign={currentCampaign}
                formTitle={'zero sum'}
                onSaveZeroSum={this.saveCampaignOptimization}
                client={client}
              />
            ) : null}
            {activeTab === TABS.CAMPAIGNS ? (
              <ThomasCampaignList
                campaigns={campaigns}
                tgramsId={tgramsId}
                productFulfillmentsVersions={productFulfillmentsVersions}
                productFulfillments={productFulfillments}
                client={client}
                optimizeCampaign={this.toggleOptimizeCampaign}
                productId={productId}
                isUserAuth={isUserAuth}
              />
            ) : (
              <P3TemplateList
                templates={templates}
                showAssignTemplate={false}
                editTemplate={this.toggleTemplateModal}
                duplicateTemplate={templateId =>
                  duplicateP3Configuration(
                    client,
                    templateId,
                    uuid(),
                    undefined,
                    tgramsId,
                    templateRefetchQueries,
                    () => toast.success('Template successfully duplicated.')
                  )
                }
                deleteTemplate={templateId =>
                  deleteP3Configuration(client, templateId, templateRefetchQueries, () =>
                    toast.success('Template successfully deleted.')
                  )
                }
                assignTemplate={templateId => {}}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default ThomasAdvertiserView;
